module.exports = __webpack_public_path__ + "img/01.fe988b53.jpg";